import { withTranslation } from "react-i18next";
import { BsFileBarGraph, BsAward } from "react-icons/bs";
import { LiaTableSolid } from "react-icons/lia";
import {
  FiTruck,
  FiAlertTriangle,
  FiSettings,
  FiFlag,
  FiMinimize,
  FiFolder,
  FiPlusSquare,
  FiArrowRightCircle,
  FiFile,
  FiHome,
  FiTool,
  FiUsers,
  FiClock,
  FiTrendingUp,
  FiBarChart
} from "react-icons/fi";
import { MdOutlineDashboard, MdOutlineStackedBarChart, MdOutlinePersonalInjury, MdPages } from "react-icons/md";
import { FaHistory } from "react-icons/fa";
export function SidebarSAdmin({ t }) {
  const menuItems = [
    {
      text: t("Home.label"),
      link: "Home",
      icon: FiHome,
      // onClick: null,
    },
    {
      text: t("Companies.label"),
      link: "list_company",
      icon: FiTruck,
      onClick: null,
    },
    // {
    //   text: t("Assessments.label"),
    //   link: "assessments",
    //   icon: FiFile,
    //   onClick: null,
    // },
    {
      text: t("IncidentType.label"),
      link: "incident_types",
      icon: MdOutlinePersonalInjury,
      onClick: null,
    },
    {
      text: t("Documents.label"),
      link: "documents",
      icon: FiFolder,
      onClick: null,
    },
    // {
    //   text: t("Configurations.label"),
    //   link: "configurations",
    //   icon: FiTool,
    //   onClick: null,
    // },
    {
      text: t("Configurations.label"),
      link: "configurations",
      icon: FiTool,
      onClick: "configurations",
      children: [
        {
          text: t("Risks.label"),
          link: "configurations",
          icon: FiAlertTriangle,
          onClick: null,
        },
        {
          text: t("Standards.label"),
          link: "std_config",
          icon: FiTrendingUp,
          onClick: null,
        },
      ],
    },
    {
      text: t("Subscriptions.label"),
      link: "subscriptions",
      icon: FiPlusSquare,
      onClick: "subscriptions",
      children: [
        {
          text: t("Plans.label"),
          link: "subscriptions",
          icon: FiPlusSquare,
          onClick: null,
        },
        {
          text: t("AssignPlan.label"),
          link: "assign_subscription",
          icon: FiPlusSquare,
          onClick: null,
        },
        {
          text: t("AssignDash.label"),
          link: "assign_graph",
          icon: FiBarChart,
          onClick: null,
        }
      ],
    },
    {
      text: t("Users.label"),
      link: "users",
      icon: FiUsers,
      onClick: null,
    },
    {
      text: "User Analytics",
      link: "user_analytics",
      icon: FiUsers,
      onClick: "user_analytics",
      children: [
        {
          text: "Online Users",
          link: "online_users",
          icon: FiUsers,
          onClick: null,
        },
        {
          text: "Pages/Sessions",
          link: "pages_session_users",
          icon: FiUsers,
          onClick: null,
        },
      ],
    },
    {
      text: t("ActivityLog.label"),
      link: "activity_log",
      icon: FiClock,
      onClick: null,
    },
    {
      text: t("OfficePages.label"),
      link: "office_pages",
      icon: FiFile,
      onClick: "office_pages",
      children: [
        {
          text: t("TermsOfUse.label"),
          link: "terms",
          icon: FiFile,
          onClick: null,
        },
        {
          text: t("PrivacyNotice.label"),
          link: "privacy_notice",
          icon: FiFile,
          onClick: null,
        },
        {
          text: t("GDPRStatement.label"),
          link: "gdpr",
          icon: FiFile,
          onClick: null,
        },
      ],
    },
    {
      text: t("Settings.label"),
      link: "not_found",
      icon: FiSettings,
      onClick: "roles",
      children: [
        {
          text: t("ESGDataset.label"),
          link: "esg_std",
          icon: BsAward,
          onClick: null,
        },
        {
          text: t("MaterialIssues.label"),
          link: "material_issues",
          icon: BsAward,
          onClick: null,
        },
        {
          text: t("StakeHolderLibrary.label"),
          link: "stakeholders",
          icon: BsAward,
          onClick: null,
        },
        {
          text: t("GeneralDisclosures.label"),
          link: "disclosures",
          icon: FiFile,
          onClick: null,
        },
        {
          text: t("Questions.label"),
          link: "question_answer_lib",
          icon: BsAward,
          onClick: null,
        },
        {
          text: t("PlatCodeMapping.label"),
          link: "plat_code_map",
          icon: BsAward,
          onClick: null,
        },
        {
          text: t("Forms.label"),
          link: "forms",
          icon: FiFile,
          onClick: null,
        },
        {
          text: t("Dashboard.label"),
          link: "dash_graph_config",
          icon: MdOutlineDashboard,
          onClick: null,
        },
        {
          text: t("GraphSets.label"),
          link: "graph_sets",
          icon: MdOutlineStackedBarChart,
          onClick: null,
        },
        {
          text: t("Roles.label"),
          link: "not_found",
          icon: FiUsers,
          onClick: null,
        },
        {
          text: t("PartnerUIConfig.label"),
          link: "partner_ui_config",
          icon: FiUsers,
          onClick: null,
        },
        {
          text: t("ConversionFactor.label"),
          link: "uom",
          icon: LiaTableSolid,
          onClick: null,
        },
        {
          text: t("EmissionFactors.label"),
          link: "ghg_datasets",
          icon: FiSettings,
          onClick: null,
        },
        {
          text: t("ReportPrompt.label"),
          link: "report_prompting",
          icon: BsAward,
          onClick: null,
        },
         {
          text: t("ConfigureThirdParties.label"),
          link: "third_parties_config",
          icon: FiSettings,
          onClick: null,
        },
        {
          text: t("EmailLog.label"),
          link: "email_log",
          icon: FaHistory,
          onClick: null,
        }
      ],
    }
  ];
  return menuItems;
}

